export enum Roles {
  SuperAdmin = "SuperAdmin",
  User = "User",

  MasterTables = "MasterTables",
  Clients = "Clients",
  BusinessDevelopment = "BussinessDevelopment",
  Production = "Production",
  CustomerService = "CustomerService",
  Claims = "Claims",
  Alert = "Alert",
  Finance = "Finance",
  HumanResource = "HumanResource",
  FixedAssets = "FixedAssets",
  SystemAdmin = "SystemAdmin",
}
